import React from "react";
import { Link } from "react-router-dom";
import productData from "../Datas/productData";
import siteConfig from "../config/siteConfig";
import "../css/about.scss";

function About() {
  return (
    <main className="about">
      <header className="about-intro">
        <p className="eyebrow">Company / point of view</p>
        <h1>Useful things<br />should still surprise.</h1>
        <p>{siteConfig.description}</p>
      </header>

      <section className="about-poster">
        <img src={productData[2].image} alt={productData[2].name} />
        <div>
          <span>01</span>
          <h2>Start with a task.</h2>
          <p>A pocket should carry something. A fastening should adjust. A fabric should suit the rhythm of the day. Function gives each piece its first line.</p>
        </div>
      </section>

      <section className="about-poster about-poster-reverse">
        <div>
          <span>02</span>
          <h2>Then make it visible.</h2>
          <p>Colour marks the construction instead of hiding it. Contrasting seams, panels and hardware turn practical decisions into a recognisable visual language.</p>
          <Link to="/shop">Browse the current release</Link>
        </div>
        <img src={productData[3].image} alt={productData[3].name} />
      </section>

      <section className="about-values">
        <article><span>01</span><h2>Focused</h2><p>A concise catalogue with a clear reason for every piece.</p></article>
        <article><span>02</span><h2>Functional</h2><p>Adjustability, useful storage and movement built into the cut.</p></article>
        <article><span>03</span><h2>Direct</h2><p>Plain product information and support at {siteConfig.contact.email}.</p></article>
      </section>
    </main>
  );
}

export default About;
